import { CategoryFilter } from "../filters/CategoryFilter"
import * as _ from 'lodash'
import { getProductsImplantations, getProductsExpositors, getProductsOutlet, getProductsPromoA, getProductsPromoB, getProductsPromoC } from "./gets"

export const selectCategoryOutlet = (props) => {
    return new Promise((resolve, reject) => {
        props.showSpinner(true)
        getProductsOutlet().then(res => {
            props.setAllProducts(res.data)
            const categoriesData = props.otherCategoriesAll
            const categoryDataOutlet = _.filter(categoriesData, { 'Name': 'Outlet' })[0]
            props.setPaginationState(1)
            props.setProductsTable('allProductsOutlet')
            const categoryFilter = new CategoryFilter('Outlet')
            props.setSelectedCategory({
                categoryId: 0,
                subtitle: categoryDataOutlet.Name,
                img: categoryDataOutlet.ImgBanner,
                selectedCollection: ''
            })
            props.resetFilters()
            props.pushFilters(categoryFilter)
            resolve()
        }).catch(err => {
            props.showSpinner(false)
            reject(err)
        })
    })
}

export const selectCategoryExpositor = (props) => {
    return new Promise((resolve, reject) => {
        props.showSpinner(true)
        getProductsExpositors().then(async res => {
            props.setAllProducts(res.data)
            const categoriesData = props.otherCategoriesAll
            const categoryDataexpositor = _.filter(categoriesData, { 'Name': 'Expositores & PLV' })[0]
            props.setPaginationState(1)
            props.setProductsTable('allProductsExpositors')
            const categoryFilter = new CategoryFilter('Expositors')
            await props.setSelectedCategory({
                categoryId: 0,
                subtitle: categoryDataexpositor.Name,
                img: categoryDataexpositor.ImgBanner,
                selectedCollection: ''
            })
            props.resetFilters()
            await props.pushFilters(categoryFilter)
            resolve()
        }).catch(err => {
            props.showSpinner(false)
            reject(err)
        })
    })
}

// export const selectCategoryImplantation = (props) => {
//     return new Promise((resolve, reject) => {
//         props.showSpinner(true)
//         getProductsImplantations().then(async res => {
//             props.setAllProducts(res.data)
//             const categoriesData = props.otherCategoriesAll
//             const categoryDataImplantation = _.filter(categoriesData, { 'Name': 'Implantationes & PLV' })[0]
//             props.setPaginationState(1)
//             props.setProductsTable('allProductsImplantations')
//             const categoryFilter = new CategoryFilter('Implantations')
//             await props.setSelectedCategory({
//                 categoryId: 0,
//                 subtitle: categoryDataImplantation.Name,
//                 img: categoryDataImplantation.ImgBanner,
//                 selectedCollection: ''
//             })
//             props.resetFilters()
//             await props.pushFilters(categoryFilter)
//             resolve()
//         }).catch(err => {
//             props.showSpinner(false)
//             reject(err)
//         })
//     })
// }

export const selectCategoryPromoA = (props) => {
    return new Promise((resolve, reject) => {
        props.showSpinner(true)
        getProductsPromoA().then(res => {
            props.setAllProducts(res.data)
            const categoriesData = props.otherCategoriesAll
            const categoryDataexpositor = _.filter(categoriesData, { 'Name': 'Promoción A' })[0]
            props.setPaginationState(1)
            props.setProductsTable('allProductsPromoA')
            const categoryFilter = new CategoryFilter('PromoA')
            props.setSelectedCategory({
                categoryId: 0,
                subtitle: categoryDataexpositor.Name,
                img: categoryDataexpositor.ImgBanner,
                selectedCollection: ''
            })
            props.resetFilters()
            props.pushFilters(categoryFilter)
            resolve()
        }).catch(err => {
            props.showSpinner(false)
            reject(err)
        })
    })
}

export const selectCategoryPromoB = (props) => {
    return new Promise((resolve, reject) => {
        props.showSpinner(true)
        getProductsPromoB().then(res => {
            props.setAllProducts(res.data)
            const categoriesData = props.otherCategoriesAll
            const categoryDataexpositor = _.filter(categoriesData, { 'Name': 'Promoción B' })[0]
            props.setPaginationState(1)
            props.setProductsTable('allProductsPromoB')
            const categoryFilter = new CategoryFilter('PromoB')
            props.setSelectedCategory({
                categoryId: 0,
                subtitle: categoryDataexpositor.Name,
                img: categoryDataexpositor.ImgBanner,
                selectedCollection: ''
            })
            props.resetFilters()
            props.pushFilters(categoryFilter)
            resolve()
        }).catch(err => {
            props.showSpinner(false)
            reject(err)
        })
    })
}

export const selectCategoryPromoC = (props) => {
    return new Promise((resolve, reject) => {
        props.showSpinner(true)
        getProductsPromoC().then(resC => {
            props.setAllProducts(resC.data)
            const categoriesData = props.otherCategoriesAll
            const categoryDataexpositor = _.filter(categoriesData, { 'Name': 'Promoción C' })[0]
            props.setPaginationState(1)
            props.setProductsTable('allProductsPromoC')
            const categoryFilter = new CategoryFilter('PromoC')
            props.setSelectedCategory({
                categoryId: 0,
                subtitle: categoryDataexpositor.Name,
                img: categoryDataexpositor.ImgBanner,
                selectedCollection: ''
            })
            props.resetFilters()
            props.pushFilters(categoryFilter)
            resolve()
        }).catch(err => {
            props.showSpinner(false)
            reject(err)
        })
    })
}

export const selectCategoryImplantations = (props) => {
    return new Promise((resolve, reject) => {
        props.showSpinner(true)
        getProductsImplantations().then(async res => {
            props.setAllProducts(res.data)
            const categoriesData = props.otherCategoriesAll
            const categoryDataImplantation = _.filter(categoriesData, { 'Name': 'Implantationes & PLV' })[0]
            props.setPaginationState(1)
            props.setProductsTable('allProductsImplantations')
            const categoryFilter = new CategoryFilter('Implantations')
            await props.setSelectedCategory({
                categoryId: 0,
                subtitle: categoryDataImplantation.Name,
                img: categoryDataImplantation.ImgBanner,
                selectedCollection: ''
            })
            props.resetFilters()
            await props.pushFilters(categoryFilter)
            resolve()
        }).catch(err => {
            props.showSpinner(false)
            reject(err)
        })
    })
};